import { Button } from '@mui/material';
import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes';
import { LEGAL_RESIDENT_QUESTIONS, SOLE_TRADER_QUESTIONS } from '../constants.tsx';
import { FormYesNoQuestion } from '~/components/FormComponents/FormYesNoQuestion';
import { styles } from '../styles';
import { useFeatureFlags } from '~/helpers/FeatureFlagsContext.tsx';
import { BaseModal } from '~/components/modals/BaseModal/BaseModal.tsx';

interface IQuestionnaireModalProps {
  isOpened: boolean;
  onContinue: (shouldExit?: boolean) => void;
}

export const QuestionnaireModal = ({ isOpened, onContinue }: IQuestionnaireModalProps) => {
  const { isLegalResident } = useGetContragentTypes();
  const {
    isCRSIFopEnabled,
    isOwnershipStructureTreeEnabled,
    isAdditionalInformationAboutTaxResidencyEnabled,
    isFATCALegalResidentEnabled,
    isFATCAFopEnabled,
  } = useFeatureFlags();

  const questions = isLegalResident
    ? LEGAL_RESIDENT_QUESTIONS(
        isOwnershipStructureTreeEnabled,
        isAdditionalInformationAboutTaxResidencyEnabled,
        isFATCALegalResidentEnabled
      )
    : SOLE_TRADER_QUESTIONS(isCRSIFopEnabled, isFATCAFopEnabled);

  const handleChange = (isChecked: boolean) => {
    if (isChecked) {
      onContinue(true);
    }
  };

  return (
    <BaseModal open={isOpened} containerProps={{ sx: styles.modalPaper }}>
      {questions.map((question) => (
        <FormYesNoQuestion
          key={question.title}
          question={question.title}
          name={question.name}
          onChange={handleChange}
        />
      ))}
      <Button variant="contained" onClick={() => onContinue()} data-testid="modal-continueBtn">
        Продовжити
      </Button>
    </BaseModal>
  );
};
